if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            new IntersectionObserver(((e, t) => {
                e[0].isIntersecting && (t.unobserve(this), fetch(this.dataset.url).then(e => e.text()).then(e => {
                    const t = document.createElement("div");
                    t.innerHTML = e;
                    const n = t.querySelector("product-recommendations");
                    n && n.innerHTML.trim().length && (this.innerHTML = n.innerHTML), !this.querySelector("slideshow-component") && this.classList.contains("complementary-products") && this.remove(), t.querySelector("c") && this.classList.add("product-recommendations--loaded")

                    var swiper = new Swiper('.slider--recommendations', {
                        slidesPerView: "auto",
                        spaceBetween: 24,
                        navigation: {
                            nextEl: '.product-recommendations .button--next',
                            prevEl: '.product-recommendations .button--prev',
                        },
                        on: {
                            init: function () {
                                var currentSlide = this.realIndex + 1;
                                var totalSlides = this.snapGrid.length; // Get the total number of slides
                                document.querySelector('.product-recommendations .swiper-slide-counter .number--first').innerText = currentSlide;
                                document.querySelector('.product-recommendations .swiper-slide-counter .number--last').innerText = totalSlides;
                            },
                            slideChange: function () {
                                var currentSlide = this.realIndex + 1;
                                var totalSlides = this.snapGrid.length; // Get the total number of slides
                                document.querySelector('.product-recommendations .swiper-slide-counter .number--first').innerText = currentSlide;
                                document.querySelector('.product-recommendations .swiper-slide-counter .number--last').innerText = totalSlides;
                            },
                        },
                    });
                    var productListImagesSwiper = new Swiper('.product-recommendations .product-list-images', {
                        slidesPerView: 1,
                        allowTouchMove: false,
                        // Navigation arrows
                        navigation: {
                            nextEl: '.product-recommendations .product-list-images-next',
                            prevEl: '.product-recommendations .product-list-images-prev',
                        },
                    });
                }).catch(e => {
                    console.error(e)
                }))
            }).bind(this), {
                rootMargin: "0px 0px 300px 0px"
            }).observe(this);
        }
    }
    customElements.define("product-recommendations", ProductRecommendations)
}